"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinearProgress = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const lodash_merge_1 = __importDefault(require("lodash.merge"));
const create_use_styles_1 = __importDefault(require("../../theming/create-use-styles"));
const color_1 = require("../../theming/utils/color");
function animationStyle(indeterminate, color, { colors }) {
    color = colors[color] || color;
    return indeterminate
        ? {
            "&::before, &::after": {
                content: "''",
                position: "absolute",
                height: "100%",
            },
            "&::before": {
                backgroundColor: color,
                animation: "$indeterminateFirst 1.5s infinite ease-out",
            },
            "&::after": {
                backgroundColor: (0, color_1.fade)(color, 0.15),
                animation: "$indeterminateSecond 1.5s infinite ease-in",
            },
        }
        : {};
}
function sizeStyle(size, { ...theme }) {
    const style = {
        small: {
            height: theme.size(4),
        },
        medium: {
            height: theme.size(8),
        },
        large: {
            height: theme.size(16),
        },
    };
    return style[size];
}
const useStyles = (0, create_use_styles_1.default)(theme => {
    const { colors } = theme;
    return {
        "indeterminate": ({ color, indeterminate }) => (0, lodash_merge_1.default)({
            "&::before, &::after": {
                content: "''",
                position: "absolute",
                height: "100%",
            },
        }, animationStyle(indeterminate, color, theme)),
        "progressBar": ({ color, value }) => {
            color = colors[color] || color;
            return {
                width: `${value}%`,
                backgroundColor: color,
            };
        },
        "track": {
            height: "100%",
        },
        "wrapper": ({ color, size }) => {
            color = colors[color] || color;
            return (0, lodash_merge_1.default)({
                position: "relative",
                overflow: "hidden",
                width: "100%",
                backgroundColor: (0, color_1.fade)(color, 0.15),
            }, sizeStyle(size, theme));
        },
        "@keyframes indeterminateFirst": {
            from: {
                left: "-100%",
                width: "100%",
            },
            to: {
                left: "100%",
                width: "10%",
            },
        },
        "@keyframes indeterminateSecond": {
            from: {
                left: "-150%",
                width: "100%",
            },
            to: {
                left: "100%",
                width: "10%",
            },
        },
    };
});
function LinearProgress({ className, color = "primary", indeterminate = false, size = "small", value = 0, ...props }) {
    const classes = useStyles({ color, indeterminate, size, value });
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(classes.wrapper, className) },
        react_1.default.createElement("div", { "aria-valuemax": 100, "aria-valuemin": 0, "aria-valuenow": value, className: (0, classnames_1.default)(classes.track, {
                [classes.indeterminate]: indeterminate,
                [classes.progressBar]: !indeterminate && typeof value === "number" && !Number.isNaN(value) && value >= 0 && value <= 100,
            }), role: "progressbar", ...props })));
}
exports.LinearProgress = LinearProgress;
exports.default = LinearProgress;
//# sourceMappingURL=data:application/json;base64,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